<template>
  <div class="container">
    <!--Section: Content-->
    <section class="formation">
      <!-- Section heading -->
      <h2 class="text-center font-weight-bold">Formations Modulables</h2>
      <!-- Section description -->
      <div class="mx-auto w-responsive">
        <div class="container">
          <!--Section: Content-->
          <section class="text-center">
            <!-- Section heading -->
            <p
              class="text-center argument font-weight-bold dark-grey-text pb-2 my-4"
            >
              <strong>Taxi & vtc formations accélérées</strong>
            </p>
            <!-- Section description -->
            <p class="text-center w-responsive mx-auto mb-5">
              Découvrez nos <strong>formations accélérées VTC</strong> & Taxi et
              optez pour une formation adaptée à votre rythme, conciliant vie
              privée et vie professionnelle.
            </p>

            <ServicePricingCarousel
              eyebrow="Formation modulable"
              :offers="carouselOffers"
            />
          </section>
          <!--Section: Content-->
        </div>
      </div>
      <div class="hr-d"></div>
      <CallToContact
        title="Contactez nous"
        subTitle="L'equipe pédagogique de l'institut taxi s'occupe de vos démarches administratives."
      />
      <!-- Grid row -->
    </section>
    <!--Section: Content-->
  </div>

  <section class="container-fluid image-block">
    <ServiceFeatureBlock
      title="Une formation qui s'adapte à votre planning"
      title-id="nightLesson"
      tone="primary"
      reverse
      :copy-html="featureCopy.intro"
    >
      <template #media>
        <img
          src="@/assets/pictures/sunshine.webp"
          alt="a-sunshine"
          class="img-fluid"
          loading="lazy"
        />
      </template>
    </ServiceFeatureBlock>
  </section>
  <HomeEnd section="VTC ou Taxi" />
</template>

<script>
import CallToContact from "@/components/plugins/CallToContact.vue";
import HomeEnd from "../home/HomeEnd.vue";
import ServiceFeatureBlock from "./ServiceFeatureBlock.vue";
import ServicePricingCarousel from "./ServicePricingCarousel.vue";

const featureCopy = {
  intro:
    "Nos <strong>formations accélérées</strong> et du soir permettent de préparer la <strong>carte taxi ou VTC</strong> avec un rythme plus souple. Le programme concentre les compétences essentielles pour avancer rapidement, sans négliger l'accompagnement pédagogique ni la qualité du parcours. L'organisation reste compatible avec votre emploi du temps, tandis que le <strong>CPF</strong>, le paiement en trois fois et l'accessibilité <strong>PMR</strong> facilitent l'entrée en formation. Cette formule permet d'avancer vite sans perdre la lisibilité du parcours ni la qualité du suivi. C'est une option pensée pour les candidats qui ont besoin d'un format plus agile, avec un cap clair, des créneaux plus flexibles et une montée en compétence plus directe.",
};

const primaryOffers = [
  {
    id: "modulable-accelerated-day",
    title: "Accélérée",
    badge: "Jour",
    price: "1100",
    fee: "+241€ frais d'examen",
    route: "/formation-vtc-initiale",
    meta: [
      { label: "Durée", value: "1 semaine" },
      { label: "Rythme", value: "Lundi au vendredi" },
      { label: "Horaires", value: "09h30 / 16h30" },
    ],
    highlights: [
      "Théorie et pratique avec véhicule",
      "Total : 1 341 €",
      "Examen blanc inclus",
    ],
  },
  {
    id: "modulable-accelerated-evening",
    title: "Accélérée",
    badge: "Soir",
    price: "1100",
    fee: "+241€ frais d'examen",
    route: "/formation-vtc-initiale",
    meta: [
      { label: "Durée", value: "1 semaine" },
      { label: "Rythme", value: "Lundi au vendredi" },
      { label: "Horaires", value: "18h00 / 21h30" },
    ],
    highlights: [
      "Théorie et pratique avec véhicule",
      "Total : 1 341 €",
      "Examen blanc inclus",
    ],
  },
  {
    id: "modulable-elearning",
    title: "E-learning",
    badge: "En ligne",
    price: "990",
    fee: "Frais d'examen inclus",
    route: "/formation-vtc-initiale",
    meta: [
      { label: "Durée", value: "1 mois" },
      { label: "Support", value: "Application ludo-pédagogique" },
      { label: "Questions", value: "Entre 1 000 et 1 500" },
    ],
    highlights: [
      "QCM, jeux, duels, etc.",
      "Théorie et pratique avec véhicule",
      "Examen blanc inclus",
    ],
  },
  {
    id: "modulable-evening",
    title: "Initiale",
    badge: "Soir",
    price: "1350",
    fee: "+237€ frais examen CMA",
    route: "/formation-vtc-initiale",
    meta: [
      { label: "Durée", value: "2 semaines" },
      { label: "Rythme", value: "Lundi au vendredi" },
      { label: "Horaires", value: "18h / 22h" },
    ],
    highlights: [
      "Examen blanc inclus",
      "Éligible CPF",
      "Paiement en 3x sans frais",
      "3 séances de conduite",
      "Véhicule mis à disposition le jour de l'examen",
    ],
  },
  {
    id: "modulable-weekend",
    title: "Initiale",
    badge: "Week-end",
    price: "1350",
    fee: "+237€ frais examen CMA",
    route: "/formation-vtc-initiale",
    meta: [
      { label: "Durée", value: "4 week-ends" },
      { label: "Rythme", value: "Samedi et dimanche" },
      { label: "Horaires", value: "9h30 / 16h30" },
    ],
    highlights: [
      "Examen blanc inclus",
      "Éligible CPF",
      "Paiement en 3x sans frais",
      "3 séances de conduite",
      "Véhicule mis à disposition le jour de l'examen",
    ],
  },
];

const secondaryOffers = [
  {
    id: "modulable-mix",
    title: "Initiale",
    badge: "Mix",
    price: "1350",
    fee: "+237€ frais examen CMA",
    route: "/contact",
    meta: [
      { label: "Format", value: "Parcours personnalisé" },
      { label: "Organisation", value: "Mixez nos formules" },
    ],
    note: {
      title: "Sur mesure",
      text: "Cette formule permet de composer un parcours soir et week-end adapté à votre planning. Elle convient aux candidats qui ont besoin d'un rythme plus souple ou d'une organisation personnalisée.",
    },
    highlights: [
      "Examen blanc inclus",
      "Éligible CPF",
      "Paiement en 3x sans frais",
      "3 séances de conduite",
      "Véhicule mis à disposition le jour de l'examen",
    ],
  },
];

const carouselOffers = [
  ...primaryOffers.map((offer) => ({
    ...offer,
    variant: "primary",
  })),
  ...secondaryOffers.map((offer) => ({
    ...offer,
    variant: "light",
  })),
];
export default {
  name: "ServicesAccelere",
  components: {
    CallToContact,
    HomeEnd,
    ServiceFeatureBlock,
    ServicePricingCarousel,
  },
  data() {
    return {
      carouselOffers,
      featureCopy,
    };
  },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(".slide-right", ".slide-left", ".fall", ".pop");
    });
  },
};
</script>

<style lang="scss" scoped>
.formation {
  & h2 {
    text-align: center;
    background-color: $color-primary;
    color: $color-secondary;
    padding: 10px;
  }
  & .argument {
    font-family: "Spartan", "Arial Black", Arial, sans-serif;
    font-weight: 700;
    font-size: 1.3em;
  }
  .price-card {
    & .card {
      color: $color-text-light;
      background: #000000; /* fallback for old browsers */
      background: -webkit-linear-gradient(
        to bottom,
        #434343,
        #000000
      ); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(
        to bottom,
        #434343,
        #000000
      ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

      display: flex;
      flex-direction: column; /* Assure un alignement vertical */
      height: 100%;
      min-height: 675px;

      & h3 {
        background-color: $color-primary;
        font-family: "quantum";
        color: $color-text-light;
        padding: 10px;
      }
      & .price {
        text-align: center;
        font-size: 2em;
        margin-bottom: 0px;
        & span {
          color: $color-secondary;
        }
      }
      & .priceBis {
        text-align: center;
        font-size: small;
        margin-bottom: 20px;
      }
      & .card-body {
        padding: 0px;
        flex-grow: 1;
        & ul {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          list-style-type: none;
          padding: 0px;
          & li,
          p {
            text-align: center;
          }
        }
      }
      & .card-footer {
        background-color: $color-secondary;
        padding: 0px;
        margin-top: auto;
        position: absolute;
        bottom: 0px;
        width: 100%;
      }
    }
  }
}

.image-block {
  padding: clamp(74px, 9vw, 108px) 20px clamp(92px, 11vw, 126px);

  @media screen and (min-width: 768px) {
    padding-inline: 28px;
  }

  @media screen and (min-width: 992px) {
    padding: clamp(88px, 9vw, 116px) clamp(28px, 4vw, 56px)
      clamp(108px, 10vw, 136px);
  }
}
.exe {
  color: $color-secondary;
  font-size: 1em;
}
.yellow {
  color: $color-secondary;
}
.slide-right.active {
  @include slide-right(1.2s);
}
.slide-left.active {
  @include slide-left(1.2s);
}
.fall.active {
  @include fall-down(1s);
}
.pop.active {
  @include fade-in(1s);
}
</style>
